import {
  InMemoryDbService,
  ParsedRequestUrl,
  RequestInfoUtilities,
} from 'angular-in-memory-web-api';
import { Injectable } from '@angular/core';

import {
  activityStreamMock,
  languagesMock,
  navigationMockUser as navigationMock,
} from '@awin/navigation-renderer';
import { userDataMock } from './user-data';
import { jwksMock } from './jwks-mock';
import { alertsMock } from './alerts-mock';

@Injectable()
export class InMemoryDataService implements InMemoryDbService {
  createDb(): unknown {
    return {
      navigationMock,
      languagesMock,
      activityStreamMock,
      userDataMock,
      jwksMock,
      alertsMock,
    };
  }

  // parseRequestUrl override
  // Do this to manipulate the request URL or the parsed result
  // into something your data store can handle.
  // This example turns a request for `/foo/heroes` into just `/heroes`.
  // It leaves other URLs untouched and forwards to the default parser.
  // It also logs the result of the default parser.
  parseRequestUrl(url: string, utils: RequestInfoUtilities): ParsedRequestUrl {
    if (url.includes('userDataMock/?networkGroup=')) {
      return utils.parseRequestUrl('api/userDataMock/');
    }
    if (url.includes('navigationMock?')) {
      return utils.parseRequestUrl('api/navigationMock/');
    }
  }
}
